import { BellOff } from 'lucide-react';
import { useMarkRead, useNotifications } from '../api/queries.ts';
import { useOrgCtx } from '../app/org-context.tsx';
import { PageHeader } from '../features/shell/Chrome.tsx';
import { EmptyState, PageLoader } from '../ui/primitives.tsx';
import { NotificationIcon } from '../features/notifications/NotificationIcon.tsx';
import { PushPrompt } from '../features/notifications/PushPrompt.tsx';
import { relativeTime } from '../lib/dates.ts';

export function InboxPage() {
  const { orgId, openTask, openContent } = useOrgCtx();
  const notifications = useNotifications(orgId);
  const markRead = useMarkRead(orgId);
  const data = notifications.data;
  const readAll = data?.unread ? (
    <button type="button" className="btn btn-plain btn-sm" onClick={() => markRead.mutate({ all: true })}>Segna tutto letto</button>
  ) : undefined;

  return (
    <div className="page wide">
      <PageHeader
        title="Inbox"
        subtitle={data ? (data.unread ? `${data.unread} da leggere` : 'Sei in pari') : undefined}
        actions={readAll}
        mobileActions={readAll}
      />
      <PushPrompt />
      {notifications.isLoading && <PageLoader />}
      {data && data.items.length === 0 && (
        <div className="card">
          <EmptyState tone="neutral" icon={<BellOff size={20} />} title="Nessuna notifica">
            Qui arrivano assegnazioni, commenti e task completate che ti riguardano.
          </EmptyState>
        </div>
      )}
      {data && data.items.length > 0 && (
        <div className="card list">
          {data.items.map((n) => (
            <button
              key={n.id}
              type="button"
              className={`inbox-item${n.readAt ? '' : ' unread'}`}
              onClick={() => {
                if (!n.readAt) markRead.mutate({ ids: [n.id] });
                if (n.entityType === 'task' && n.entityId) openTask(n.entityId);
                if (n.entityType === 'content_item' && n.entityId) openContent(n.entityId);
              }}
            >
              <NotificationIcon n={n} size={36} />
              <span className="grow">
                <span className="title">{n.title}</span>
                {n.body && <span className="body">{n.body}</span>}
              </span>
              <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6 }}>
                <time dateTime={n.createdAt}>{relativeTime(n.createdAt)}</time>
                {!n.readAt && <span className="dot" aria-label="Non letta" />}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
